
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"green-leaf-bottom",attrs:{"d":"M6.397 3.02c2.865-1.22 5.467-1.092 6.784-.888a.196.196 0 01.164.217c-.237 2.151-.573 5.846-3.502 8.215-1.88 1.52-4.89 1.07-5.638.927a.201.201 0 00-.23.132c-.083.25-.229.728-.26 1.083a4.175 4.175 0 00.2 1.668c.048.139-.051.293-.198.293H2.55a.195.195 0 01-.192-.153c-.081-.375-.272-1.352-.208-1.979.103-1.012.418-1.721.717-2.368a.195.195 0 00.019-.073c.09-1.878-.138-5.52 3.51-7.074z","fill":"var(--color-green-leaf-icon-color-bottom)"}}),_c('path',{staticClass:"green-leaf-top",attrs:{"d":"M13.248 2.143C11.3 3.32 9.46 5.125 7.834 6.72c-2.047 2.008-3.76 3.688-4.933 3.38l-.014-.026c.007-.157.012-.326.018-.504.06-1.968.158-5.131 3.492-6.551 2.914-1.242 5.556-1.087 6.85-.877z","fill":"var(--color-green-leaf-icon-color-top)"}})])
          )
        }
      }
    